import { render } from "./Avatar.vue?vue&type=template&id=6949a1e4&scoped=true&ts=true"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"

import "./Avatar.vue?vue&type=style&index=0&id=6949a1e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6949a1e4"]])

export default __exports__